import { createSlice } from '@reduxjs/toolkit';

/**
 * Redux slice for managing check-in flow state
 * Stores information like current step, device check status, etc.
 */
const checkInSlice = createSlice({
  name: 'checkIn',
  initialState: {
    currentStep: 0,
    deviceCheckFailed: false,
    isReturningUser: false,
    shortUrl: null,
    currentFormId: null,
    currentFormVersion: null
  },
  reducers: {
    setCurrentStep: (state, action) => {
      state.currentStep = action.payload;
    },
    setCurrentFormId: (state, action) => {
      state.currentFormId = action.payload;
    },
    setCurrentFormVersion: (state, action) => {
      state.currentFormVersion = action.payload;
    },
    setDeviceCheckFailed: (state, action) => {
      state.deviceCheckFailed = action.payload;
    },
    setIsReturningUser: (state, action) => {
      state.isReturningUser = action.payload;
    },
    setShortUrl: (state, action) => {
      state.shortUrl = action.payload;
    },
    resetCheckInState: (state) => {
      state.currentStep = 0;
      state.deviceCheckFailed = false;
      state.isReturningUser = false;
      state.shortUrl = null;
      state.currentFormId = null;
      state.currentFormVersion = null;
    }
  }
});

// Export actions
export const { 
  setCurrentStep, 
  setDeviceCheckFailed,
  setIsReturningUser,
  setShortUrl,
  setCurrentFormId,
  setCurrentFormVersion,
  resetCheckInState
} = checkInSlice.actions;

// Selectors
export const selectCurrentStep = (state) => state.checkIn.currentStep;
export const selectDeviceCheckFailed = (state) => state.checkIn.deviceCheckFailed;
export const selectIsReturningUser = (state) => state.checkIn.isReturningUser;
export const selectShortUrl = (state) => state.checkIn.shortUrl;
export const selectCurrentFormId = (state) => state.checkIn.currentFormId;
export const selectCurrentFormVersion = (state) => state.checkIn.currentFormVersion;

export default checkInSlice.reducer;
